import React, { memo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Trash2, ChevronRight, FilePlus2 } from 'lucide-react'
import '../shared/AccordianStyle.css'
import { motion, AnimatePresence } from 'framer-motion'
import { CFormCheck } from '@coreui/react'

const SchedulerAccordian = ({ title, content, onHeaderClick, handleDeleteData, type, handleSelectAll, isFacilityFullySelected, handleFacilitySelectAll, handleAvialableProvider, patientData, AppointmentID, appointmentScheduleDate, patientStatus = 'Newpatient' }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [showCreateNote, setShowCreateNote] = useState(false)
  const history = useHistory()

  // const toggleAccordion = () => {
  //     if (!linkQuestion) {
  //         setIsOpen(!isOpen);
  //     } else {
  //         //   setActiveAccordion(isActive ? null : idx);
  //     }

  // };
  const toggleAccordion = () => {
    if (typeof onHeaderClick === 'function') {
      onHeaderClick()
    }

    setIsOpen((prev) => !prev)
  }

  const handleCreateNote = () => {
    localStorage.setItem('patientInfoData', JSON.stringify(patientData))
    localStorage.setItem('patientPassingAppointmentID', JSON.stringify(AppointmentID))
    localStorage.setItem('noteButtonContext', 'scheduler')
    if (appointmentScheduleDate) {
      localStorage.setItem('schedulerAppointmentDate', appointmentScheduleDate)
    }

    if (patientData?.length > 0 && AppointmentID) {
      history.push({
        pathname: '/home/appointment',
        state: {
          patientInfoData: patientData,
          patientPassingAppointmentID: AppointmentID,
          noteButtonContext: 'scheduler',
          schedulerAppointmentDate: appointmentScheduleDate,
        },
      })
    }
  }

  const isFacilityAccordion = type == 'facility' || type == 'facilityType'
  const appointmentStateClass = patientStatus == 'NewPatient' ? 'scheduler-theme__accordion--new' : 'scheduler-theme__accordion--followup'

  return (
    <div className={`accordion-item w-full accordion-scope border mt-1 scheduler-theme__accordion ${isFacilityAccordion ? 'scheduler-theme__accordion--facility' : `scheduler-appointment-accordion ${appointmentStateClass}`}`}>
      <h2 className="accordion-header">
        <div
          className={`accordion-button ${!isOpen ? 'collapsed' : ''} d-flex justify-content-between align-items-center scheduler-theme__accordion-button ${isFacilityAccordion ? 'p-2' : ''}`}
          type="button"
          onClick={toggleAccordion}
        >
          {type === 'facilityType' ? (
            <div className="d-flex align-items-center justify-content-center gap-2">
              <div>
                <CFormCheck className="ui-checkbox" checked={isFacilityFullySelected} onChange={(e) => handleFacilitySelectAll?.(e.target.checked)} style={{ marginBottom: 0, width: '14px', height: '14px' }} />
              </div>
              <div className="mt-1 scheduler-theme__accordion-title">
                {title}
              </div>
            </div>
          ) : (
            title
          )}

          <div className="scheduler-appointment-actions">
            <span className="custom-icon ms-auto d-flex gap-1">
              {type == 'facility' || type == 'facilityType' ? '' : <Trash2 size={20} strokeWidth={1.5} onClick={handleDeleteData} />}
              {type == 'facility' || type == 'facilityType' ? '' : <FilePlus2 size={20} strokeWidth={1.5} onClick={() => handleCreateNote()} />}
              <ChevronRight size={20} strokeWidth={1.5} onClick={toggleAccordion} className={`scheduler-theme__accordion-arrow ${isOpen ? 'scheduler-theme__accordion-arrow--open' : ''}`} />
            </span>
          </div>
        </div>
      </h2>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div className="accordion-collapse" initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3, ease: 'easeInOut' }}>
            <div className="accordion-body">{content}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default memo(SchedulerAccordian)
